module.exports = __webpack_public_path__ + "img/sweden-pneumonia-female.47edff0d.png";